import { render, staticRenderFns } from "./huifu.vue?vue&type=template&id=650330fa&scoped=true&"
import script from "./huifu.vue?vue&type=script&lang=js&"
export * from "./huifu.vue?vue&type=script&lang=js&"
import style0 from "./huifu.vue?vue&type=style&index=0&id=650330fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650330fa",
  null
  
)

export default component.exports